import * as Sentry from '@sentry/nuxt'

Sentry.init({
  dsn: 'https://2704aaeff75a2b7f6e309813c3095747@sentry.hamravesh.com/10689',
})
